import { render, staticRenderFns } from "./CardPurchase.vue?vue&type=template&id=53655445&scoped=true&"
import script from "./CardPurchase.vue?vue&type=script&lang=js&"
export * from "./CardPurchase.vue?vue&type=script&lang=js&"
import style0 from "./CardPurchase.vue?vue&type=style&index=0&id=53655445&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53655445",
  null
  
)

export default component.exports